/**
 *  @internal Type of action to invoke the cart's _action method with
 *  that sets the pending state of the checkout details and emits them
 */
export var CartAction;
(function (CartAction) {
    /**
     *  Adds a pending count to the pending actions
     *  and emits the current checkout details
     *  with pending set to true.
     */
    CartAction["Start"] = "start";
    /**
     *  Subtracts a pending count from the pending actions and
     *  emits the current checkout details, with the pending set
     *  based on the current pending actions.
     */
    CartAction["End"] = "end";
})(CartAction || (CartAction = {}));
/**
 *  Possible type of cart item children.
 */
export var CartItemChildType;
(function (CartItemChildType) {
    CartItemChildType["Tickets"] = "tickets";
    CartItemChildType["Products"] = "products";
})(CartItemChildType || (CartItemChildType = {}));
/**
 *  Possible type of a cart item.
 */
export var CartItemType;
(function (CartItemType) {
    CartItemType["Ticket"] = "ticket";
    CartItemType["Product"] = "product";
})(CartItemType || (CartItemType = {}));
/**
 *  Terms actions.
 *
 *  The possible actions allowed on terms.
 */
export var TermsActions;
(function (TermsActions) {
    TermsActions["Accept"] = "Accept";
    TermsActions["Reject"] = "Reject";
})(TermsActions || (TermsActions = {}));
//# sourceMappingURL=types.js.map